import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceGetStartedRoute: InvariantJiraRoute = {
	name: 'customer-service-get-started',
	path: '/jira/servicedesk/projects/:projectKey/get-started',
	exact: true,
};
